import {
  ContrastIcon,
  EraserIcon,
  type IconComponent,
  ScalingIcon,
  SparklesIcon,
  SquareRoundCornerIcon,
  StampIcon,
} from '@air/design-icons';

export type GuidedVariantEditId =
  | 'grayscale'
  | 'remove-background'
  | 'resize'
  | 'rounded-corners'
  | 'smart-resize'
  | 'watermark';

export type GuidedVariantEditOption = {
  hint?: string;
  icon: IconComponent;
  id: GuidedVariantEditId;
  label: string;
};

/** Smart resize and Scale or crop lead as cards. The rest are half-width chips in the same grid. */
export const GUIDED_VARIANT_EDIT_OPTIONS = [
  {
    hint: 'Reformat content and extend with AI for any size',
    icon: SparklesIcon,
    id: 'smart-resize',
    label: 'Smart resize',
  },
  {
    hint: 'Same aspect ratio, or a simple crop',
    icon: ScalingIcon,
    id: 'resize',
    label: 'Scale or crop',
  },
  {
    icon: StampIcon,
    id: 'watermark',
    label: 'Watermark',
  },
  {
    icon: ContrastIcon,
    id: 'grayscale',
    label: 'Grayscale',
  },
  {
    icon: SquareRoundCornerIcon,
    id: 'rounded-corners',
    label: 'Rounded corners',
  },
  {
    icon: EraserIcon,
    id: 'remove-background',
    label: 'Remove background',
  },
] satisfies readonly GuidedVariantEditOption[];

export const isGuidedVariantEditId = (value: string): value is GuidedVariantEditId =>
  GUIDED_VARIANT_EDIT_OPTIONS.some((option) => option.id === value);

/** Smart resize and Scale or crop keep videos; other edits skip them. */
export const GUIDED_VARIANT_EDITS_THAT_HANDLE_VIDEOS: readonly GuidedVariantEditId[] = ['resize', 'smart-resize'];

export const doesGuidedVariantEditHandleVideos = (edit: GuidedVariantEditId): boolean =>
  GUIDED_VARIANT_EDITS_THAT_HANDLE_VIDEOS.some((id) => id === edit);

export const WORKSPACE_AGENT_GUIDED_VARIANT_SUGGESTION_IDS = [
  'hero-artist-variants',
  'uploaded-batch-variants',
] as const;

export const isWorkspaceAgentGuidedVariantSuggestionId = (id: string) =>
  WORKSPACE_AGENT_GUIDED_VARIANT_SUGGESTION_IDS.some((suggestionId) => suggestionId === id);
